__webpack_require__.p = "/tamil-typing/_next/";